import { fetchMatches } from '../../../entities/match';

export const scope = 'MATCHES_LIST_WIDGET';

export function fetchMatchesIfNeeded(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.matches.listWidget;

        if (!widget.info.isFetching)
            dispatch(fetchMatches(payload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/onSite/matches/listWidget.js